module.exports = __webpack_public_path__ + "img/65.c2e3e617.jpg";